
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as farmService from '@/services/farmService';
import type { Farm, CreateFarmInput } from '@/types/database.types';

// Farm hooks
export const useGetFarms = () => {
  return useQuery({
    queryKey: ['farms'],
    queryFn: farmService.getFarms
  });
};

export const useGetFarmById = (id: string) => {
  return useQuery({
    queryKey: ['farms', id],
    queryFn: () => farmService.getFarmById(id),
    enabled: !!id
  });
};

// Use the CreateFarmInput type from database.types
export const useCreateFarm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: farmService.createFarm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['farms'] });
    }
  });
};

export const useUpdateFarm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string, data: Partial<Farm> }) => 
      farmService.updateFarm(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['farms'] });
      queryClient.invalidateQueries({ queryKey: ['farms', variables.id] });
    }
  });
};

export const useDeleteFarm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: farmService.deleteFarm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['farms'] });
    }
  });
};
